module.exports = __webpack_public_path__ + "img/1992_L.011412f3.png";